import React, { FC, useCallback, useMemo } from 'react';
import omit from 'lodash/omit';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import IconButton from 'components/buttons/IconButton';

import { useModal } from 'vibo-ui/Modal';
import { useNotifications } from 'components/context/NotificationsContext';

import { ButtonIconType, Modals, NotificationStatus } from 'types/enums';
import { CustomNotificationModalProps } from 'components/modals/CustomNotificationModal';
import { EventCustomNotification } from 'components/context/NotificationsContext/interfaces';

import useDecorStyles from 'components/buttons/IconButton/decorStyle';

const CustomNotifTools: FC<EventCustomNotification> = notification => {
  const decorStyles = useDecorStyles();
  const { t } = useTranslation();

  const { canAddNotif, remove, create, update } = useNotifications();

  const { openModal } = useModal();

  const handleChangeNotif = useCallback(
    (props: CustomNotificationModalProps) => () => {
      openModal<CustomNotificationModalProps>({
        key: Modals.customNotification,
        props,
      });
    },
    [notification]
  );
  const handleRemoveNotif = useCallback(() => remove(notification._id), [notification._id]);

  const isSent = useMemo(() => notification.status === NotificationStatus.sent, [
    notification.status,
  ]);

  return (
    <div className="tools">
      {isSent ? null : (
        <IconButton
          onClick={handleChangeNotif({
            notification,
            update,
          })}
          title={t('editNotification')}
          type={ButtonIconType.edit}
          className={decorStyles.highlighted}
        />
      )}
      {canAddNotif ? (
        <IconButton
          onClick={handleChangeNotif({
            notification: omit(notification, '_id'),
            create,
          })}
          title={t('cloneNotification')}
          type={ButtonIconType.clone}
          className={decorStyles.highlighted}
        />
      ) : null}
      {isSent ? null : (
        <IconButton
          onClick={handleRemoveNotif}
          title={t('deleteNotification')}
          type={ButtonIconType.delete}
          className={classNames(decorStyles.highlighted, 'danger')}
        />
      )}
    </div>
  );
};

export default CustomNotifTools;
